import { FormattedMessage } from 'react-intl';
import FormattedCurrency from '../../atoms/FormattedCurrency';

type ReturnCostInfo = {
  hasReturnCosts?: boolean;
  returnServiceCost?: number;
  minGrossOrderValueAfterReturns?: number;
};

const getReturnCostHint = ({ hasReturnCosts, returnServiceCost, minGrossOrderValueAfterReturns }: ReturnCostInfo) => {
  if (!hasReturnCosts || !returnServiceCost || !minGrossOrderValueAfterReturns) {
    return undefined;
  }
  return (
    <FormattedMessage
      id="basket.toolTip.return"
      values={{
        returnServiceCost: <FormattedCurrency value={returnServiceCost} />,
        minGrossOrderValueAfterReturns: <FormattedCurrency value={minGrossOrderValueAfterReturns} />
      }}
    />
  );
};

type ShippingCostInfo = { isShippingCostHintEnabled?: boolean; hasFreeShipping?: boolean };

const getShippingCostHint = ({ isShippingCostHintEnabled, hasFreeShipping }: ShippingCostInfo) => {
  if (!isShippingCostHintEnabled) {
    return undefined;
  }
  return <FormattedMessage id={`basket.toolTip.${hasFreeShipping ? 'free' : 'standard'}`} />;
};

const getInfoBoxTexts = ({
  shippingCostInfo,
  returnCostInfo
}: {
  shippingCostInfo: ShippingCostInfo;
  returnCostInfo: ReturnCostInfo;
}) => [getShippingCostHint(shippingCostInfo), getReturnCostHint(returnCostInfo)].filter(Boolean);

export default getInfoBoxTexts;
